import type { MobilityAd } from "@mobility-item-page/types";
import { hasServiceHistoryInfo } from "src/utils/safetyElements.ts";

type Props = {
  ad: MobilityAd;
};
const ServiceHistory = ({ ad }: Props) => {
  if (hasServiceHistoryInfo(ad) && ad.service_history_info?.description) {
    return <p className="mb-0 whitespace-pre-line">{ad.service_history_info.description}</p>;
  }
  return null;
};

export default ServiceHistory;
